import { View } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { StyleSheet } from 'react-native'
import { ActualiteItemResult } from '../../../api/GridPage/types'
import { CardLineItem } from './CardLineItem.component'

interface CardsLineProps {
  items: ActualiteItemResult[]
  height: number
}

export const CardsLine: FunctionComponent<CardsLineProps> = props => (
  <View style={cardsStyle.content}>
    {props.items.map((item, index) => (
      <CardLineItem key={index} item={item} height={props.height} />
    ))}
  </View>
)

export const cardsStyle = StyleSheet.create({
  content: {
    flex: 1,
  },
})
